import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from '../../layouts/dashboard';
import { RoutesDetail } from '../../../components/Routes/RoutesDetail';

export const RouteDetailsPage = () => {
  return (
    <DashboardLayout title={'Rutas'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <RoutesDetail />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
